









































import { Component, Vue, Prop } from 'vue-property-decorator';
import { translationSvc } from '@/services';
import { Translation } from '@/types';
import { uniq } from 'lodash';

@Component({
  name: 'new-translation'
})
export default class NewTranslation extends Vue {
  @Prop()
  translations!: Translation[];

  @Prop()
  locales!: String[];

  isLoading: boolean = false;

  namespace: string = '';
  group: string = '';
  locale: string = '';
  key: string = '';
  value: string = '';

  queryNamespace(query: string, cb: Function) {
    let namespaces = this.namespaces;
    if (query) {
      namespaces = namespaces.filter((namespace: string | undefined) =>
        namespace!.toLowerCase().includes(query.toLowerCase())
      );
    }
    cb(
      namespaces.map(namespace => {
        return { value: namespace, label: namespace };
      })
    );
  }

  queryGroup(query: string, cb: Function) {
    let groups = this.groups;
    if (query) {
      groups = groups.filter((group: string | undefined) =>
        group!.toLowerCase().includes(query.toLowerCase())
      );
    }
    cb(
      groups.map(group => {
        return { value: group, label: group };
      })
    );
  }

  queryLocale(query: string, cb: Function) {
    let locales = this.locales;
    if (query) {
      locales = locales.filter((locale: String) =>
        locale!.toLowerCase().includes(query.toLowerCase())
      );
    }
    return cb(
      locales.map(locale => {
        return { value: locale, label: locale };
      })
    );
  }

  get groups() {
    return uniq(this.translations.map(translation => translation.group));
  }

  get namespaces() {
    return uniq(this.translations.map(translation => translation.namespace));
  }

  async saveNewTranslation() {
    this.isLoading = true;
    try {
      const translation = await translationSvc.createTranslation({
        namespace: this.namespace,
        group: this.group,
        key: this.key,
        value: this.value,
        locale: this.locale
      });
      this.$emit('onNewTranslation', translation);
    } catch (e) {
      // empty
    }
    this.isLoading = false;
  }
}
